import BedIcon from "@mui/icons-material/Bed";
import { ROOMS, DormitoryServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListRooms from "./List";
import CreateRoom from "./Create";
import EditRoom from "./Edit";

export const resources = {
  isMenu: true,
  icon: <BedIcon />,
  name: DormitoryServicePath + ROOMS,
  title: "Стаи",
  list: <ListRooms />,
  create: <CreateRoom />,
  createPermission: permissions.canManageDormitoryRooms,
  edit: <EditRoom />,
  editPermission: permissions.canManageDormitoryRooms,
  permission: permissions.canPreviewDormitoryRooms,
};
